function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["src", "format", "resize", "quality", "progressive", "loading", "s3_process_disabled", "fallback_to_origin_src"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { memo, useContext, useEffect, useState } from 'react';
import { getValues } from "../../../lib/utils";
import { ProgressiveImage } from "./progressive";
import { getProcessedSrcset, getProcessedUrl } from "./utils/get-processed-url";
import { isImageValid } from "./utils/is-image-valid";
import { isSupportedDomain } from "./utils/s3-path";

// 功能
// [x] 1. 支持图片格式转换
// [x] 2. 支持图片压缩
// [x] 3. 支持图片裁剪
// [x] 3. 支持图片懒加载
// [ ] 4. 支持图片占位符
// [x] 5. 支持渐进式加载
//
import { jsx as _jsx } from "react/jsx-runtime";
var ImageContext = /*#__PURE__*/React.createContext({});
export var ImageProvider = ImageContext.Provider;
export var Image = /*#__PURE__*/memo(function Image(props) {
  var src = props.src,
    _props$format = props.format,
    format = _props$format === void 0 ? 'auto' : _props$format,
    resize = props.resize,
    quality = props.quality,
    progressive = props.progressive,
    loading = props.loading,
    s3_process_disabled = props.s3_process_disabled,
    _props$fallback_to_or = props.fallback_to_origin_src,
    fallback_to_origin_src = _props$fallback_to_or === void 0 ? true : _props$fallback_to_or,
    others = _objectWithoutProperties(props, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFallback = _useState2[0],
    setIsFallback = _useState2[1];
  var vals = useContext(ImageContext);

  // 处理默认值
  var s3_disable_option = !isSupportedDomain(src) || getValues([s3_process_disabled, vals.s3_process_disabled], false);
  var loading_option = getValues([loading, vals.loading], 'lazy');

  // 获取处理后的url
  var final_url = !s3_disable_option ? getProcessedSrcset(src, {
    format: format,
    resize: resize,
    quality: quality
  }) : src;

  // 支持渐进式加载
  var progressive_enabled = progressive && !s3_disable_option;
  useEffect(function () {
    isImageValid(final_url).then(function (valid) {
      if (!valid) {
        console.warn("[invalid] image: ".concat(src));
        if (fallback_to_origin_src) {
          setIsFallback(true);
        }
      }
    }).catch(function (err) {
      console.warn("detect image valid error: ".concat(err));
      setIsFallback(true);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 发生错误回退到原始图片
  if (isFallback) {
    return /*#__PURE__*/_jsx("img", _objectSpread({
      src: src,
      loading: loading_option
    }, others));
  }

  // 启用渐进式加载
  if (progressive_enabled) {
    var blur_src = getProcessedUrl(src, {
      format: format,
      resize: resize,
      quality: quality,
      thumbnail: true
    });
    return /*#__PURE__*/_jsx(ProgressiveImage, _objectSpread({
      src: final_url,
      blur_src: blur_src,
      loading: loading_option
    }, others));
  }
  return /*#__PURE__*/_jsx("img", _objectSpread({
    srcSet: final_url,
    loading: loading_option
  }, others));
});